import { MissionDetail } from '@/features/missions/components/MissionDetail'
import { MissionsUrlProvider } from '@/features/missions/context/MissionsUrlProvider'
import { Page } from '@/ui-kit'
import { useParams } from 'react-router-dom'

const MissionDetailPage = () => {
  const { id } = useParams<{ id: string }>()

  return (
    <MissionsUrlProvider isWebview={false}>
      <Page>
        <MissionDetail missionId={id ?? ''} />
      </Page>
    </MissionsUrlProvider>
  )
}

export default MissionDetailPage
